import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { ClipboardCheck } from "lucide-react";

export const Inspections = () => {
  const { data } = useQuery({
    queryKey: ["inspections"],
    queryFn: async () => (await api.get("/inspections")).data,
  });
  const items = data || [];
  return (
    <div className="space-y-6" data-testid="page-inspections">
      <header>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#7C93A5]">Inspection360™</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Field Inspection Register</h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">GPS-anchored, offline-capable field verification with statutory evidence chain.</div>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.map((i) => (
          <div key={i.id} className="cad-panel p-4" data-testid={`inspection-${i.id}`}>
            <div className="flex items-center justify-between">
              <div className="font-mono-cad text-[10px] uppercase tracking-[0.22em] text-[#C99A2E]">{i.subject_type.replace("_", " ")}</div>
              <span className={`cad-chip ${i.status === "completed" ? "cad-chip-green" : i.status === "in_progress" ? "cad-chip-gold" : "cad-chip-blue"}`}>{i.status.replace(/_/g, " ")}</span>
            </div>
            <div className="font-display text-lg font-bold text-[#F6F8FA] mt-1 flex items-center gap-1.5">
              <ClipboardCheck size={16} className="text-[#C99A2E]" /> {i.subject_ref}
            </div>
            <dl className="mt-2 text-[12px] space-y-1 text-[#B3C2CC]">
              <div className="flex justify-between"><dt>Province</dt><dd className="text-[#F6F8FA]">{i.province}</dd></div>
              <div className="flex justify-between"><dt>District</dt><dd className="text-[#F6F8FA]">{i.district}</dd></div>
              <div className="flex justify-between"><dt>Assigned</dt><dd className="text-[#F6F8FA]">{i.assigned_to}</dd></div>
              <div className="flex justify-between"><dt>Scheduled</dt><dd className="text-[#F6F8FA] font-mono-cad">{(i.scheduled_for || "").slice(0, 10)}</dd></div>
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
};
